import React, { useContext } from 'react'

import { WebSocketsSharedContext } from '../../integrations/WebSockets'

import GreetingPopup from './GreetingPopup'

const StartPopup = ({
  closePopup,
  authorized,
  greeting,
  submitPopup
}) => {
  const { initializeConversation } = useContext(WebSocketsSharedContext)

  const handleClosePopup = e => {
    e.stopPropagation()
    closePopup()
  }

  const handleSubmitPopup = () => {
    if (greeting?.payload && authorized) {
      const message = {
        type: 'postback',
        payload: greeting.payload,
        isRtl: false
      }
      initializeConversation(message)
    }

    submitPopup()
  }

  return (
    <GreetingPopup
      dataTest={'pop-up-msg'}
      handleClosePopup={handleClosePopup}
      handleSubmitPopup={handleSubmitPopup}
      text={greeting?.greetingText}
    />
  )
}

export default StartPopup
